import React from 'react'

interface BalanceProgressBarProps {
    percentage: number
    leftToSpend: string
    available: string
    showAsterisk?: boolean
    showAvailableToSpend?: boolean
    onClick?: () => void
}

const BalanceProgressBar: React.FC<BalanceProgressBarProps> = ({
    percentage,
    leftToSpend,
    available,
    showAsterisk = false,
    onClick,
    showAvailableToSpend = true
}) => {
    const percentageDisplay = `${percentage}%`

    return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
            className="flex-1 flex items-start gap-3 lg:max-w-[1450px] hover:cursor-pointer"
            onClick={onClick}
        >
            <div className="relative border-2 border-gray-02 flex-1 h-3.5 rounded-[1.5625rem]">
                <div
                    className="absolute h-3.5 rounded-[1.5625rem] -left-0.5 -top-0.5 bg-blue-600"
                    style={{
                        width: percentage > 0 ? `max(${percentageDisplay}, 8px)` : '0%'
                    }}
                ></div>
            </div>
            {showAvailableToSpend && (
                <div className="text-right whitespace-nowrap leading-tight">
                    <div className="font-grotesque text-xs font-medium" style={{color: '#004968'}}>
                        <span className="font-bold">{leftToSpend}</span>
                        <span>
                            /{available}
                            {showAsterisk ? '*' : ''}
                        </span>
                    </div>
                    <div className="text-xs" style={{color: '#004968'}}>
                        Available to Spend
                    </div>
                </div>
            )}
        </div>
    )
}

export default BalanceProgressBar
